/* eslint-disable angular/factory-name */

angular.module("digiexam.exam").factory("Alternative", function alternativeFactory() {
	"use strict";

	function Alternative(data) {
		var dirty = false;

		angular.extend(this, {
			id: 0,
			title: "",
			right: false,

			isValid: function isValid() {
				return this.title !== "";
			},
			isDirty: function isDirty() {
				return dirty;
			},
			setDirty: function setDirty(state) {
				dirty = state;
			},
		});

		if (data) {
			angular.extend(this, data);
		}
	}

	return Alternative;
});
